<template>
  <nav class="topheader">
    <router-link to="/">
      <h1>Klaar voor kinderen?</h1>
    </router-link>
    <div class="infobutton" @click="openCloseInfoScreen">{{icon}}</div>
  </nav>
</template>

<script>
export default {
  props: ["icon"],
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openCloseInfoScreen() {
      if (this.icon == "?") {
        this.isOpen = true;
        this.$router.push({ name: "info" });
      } else {
        this.isOpen = false;
        this.$router.go(-1);
      }
    }
  },
  created() {
    //console.log('isOpen is: ' + this.isOpen);
    this.isOpen = false;
  },
  updated() {
    //console.log('UPDATED: isOpen is: ' + this.isOpen);
  },
  mounted() {
    //console.log('MOUNTED: isOpen is: ' + this.isOpen);
  },
  watch: {
    $route(to, from) {
      if (from.name == "info") {
        this.isOpen = false;
      }
    }
  }
};
</script>

<style>
.topheader {
  font-family: "Playfair Display";
  font-size: 1.6rem;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;

  display: flex;
  justify-content: space-between;
  padding: 2.6rem 1.8rem 0 1.8rem;
}

.topheader .router-link-active:link,
.topheader .router-link-active:visited,
.topheader .router-link-active:active {
  color: var(--titleslidecolor);
  text-decoration: none;
}

.infobutton {
  font-family: "Playfair Display";
  font-size: 1.6rem;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: var(--titleslidecolor);
  text-decoration: none;
  background-image: url("../assets/img/oval.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 21px;
  height: 21px;
  text-align: center;
  cursor: pointer;
}

/* large */
@media only screen and (min-width: 1200px) {
  .topheader {
    font-size: 2rem;
    font-weight: 900;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    padding-top: 5.3rem;
  }
  .infobutton {
    width: 26px;
    height: 26px;
    line-height: 2.5rem;
  }
}
</style>

